<template>
  <div id="loaderWrap">
    <loader></loader>
  </div>
</template>

<script>
import { mapState} from "vuex";

export default {
  name: "instLoaderGetDemandState",
  components:{
    loader: () => import('@/views/pdlloan/uiLoader'),
  },
  computed: {
    ...mapState({
      demandState: state => state.instForm.demandState,
      inst_formStatus: state => state.instForm.inst_formStatus,
      valuesVuex: state => state.Form.sendData
    }),
  },
  watch: {
    // 'demandState.demandState'(newVal) {
    //   console.log('watch demandState.demandState')
    //   console.log(newVal)
    //   switch (newVal){
    //     case -1:
    //       this.$store.dispatch('inst_trySetSystemScreen', 'instRejectTime');
    //       break;
    //     case 1:
    //       this.$store.dispatch('inst_trySetSystemScreen', 'instApproveDemandEasy');
    //       break;
    //     case 2:
    //       this.$store.dispatch('inst_trySetSystemScreen', 'instApproveDemandDefault');
    //       break;
    //     case 0:
    //       this.calcScreenForFirst();
    //       break;
    //   }
    // },
    // 'demandState.allPhotosAttached'(newVal){
    //   console.log('watch  demandState.allPhotosAttached')
    //   console.log(newVal)
    //   this.calcScreenForFirst();
    // },
    // 'demandState.easyAV'(newVal){
    //   console.log('watch  demandState.easyAV')
    //   console.log(newVal)
    //   this.calcScreenForFirst();
    // },
    // 'demandState.boxSelected'(newVal){
    //   console.log('watch  demandState.boxSelected')
    //   console.log(newVal)
    //   this.calcScreenForFirst();
    // },
    // 'demandState.CodeSent'(newVal){
    //   console.log('watch  demandState.CodeSent')
    //   console.log(newVal)
    //   this.calcScreenForFirst();
    // },
    // 'demandState.bindigPayment'(newVal){
    //   console.log('watch  demandState.bindigPayment')
    //   console.log(newVal)
    //   this.calcScreenForFirst();
    // }
  },
  methods: {
    async calcScreenForFirst() {
      // console.log('calcScreenForFirst')
      // console.log(this.inst_formStatus.systemScreen)
      // console.log('!!!!!!!!!!!!!!!!!!!')

      if (process.env.NODE_ENV === 'development') {
        console.log('if dev running')
        // this.$store.dispatch('inst_initForm', 'documents');
        // this.$store.dispatch('inst_initForm', 'box');
        this.$store.dispatch('inst_initForm', 'iuConfirm');
        return;
      }

      if (this.demandState.demandState !== 0) {
        console.log('demandState !== 0')
        return;
      }

      if (this.demandState.allPhotosAttached === 0) {
        console.log('allPhotosAttached === 0')
        this.$store.dispatch('inst_initForm', 'documents');
        return;
      }
      if (this.demandState.bindigPayment === 0) {
        console.log('bindigPayment === 0')
        this.$store.dispatch('inst_initForm', 'bindigPayment');
        return;
      }
      if (this.demandState.easyAV === 0) {
        console.log('easyAV === 0')
        this.$store.dispatch('inst_initForm', 'anketa');
        return;
      }
      // if (this.demandState.boxSelected === 0) {
      //   console.log('boxSelected === 0')
      //   this.$store.dispatch('inst_initForm', 'box');
      //   return;
      // }
      if (this.demandState.CodeSent === 0) {
        console.log('iuConfirm === 0')
        console.log('await instGetBoxArr');
        await this.$store.dispatch('instGetBoxArr');
        console.log('await end instGetBoxArr');
        this.$store.dispatch('inst_initForm', 'iuConfirm');
        return;
      }
      if (this.demandState.easyAV === 1
          && this.demandState.allPhotosAttached === 1
          && this.demandState.boxSelected === 1
          && this.demandState.CodeSent === 1
      ) {
        document.location.href = 'https://lk.msk.finmoll.com/public/confirm?request=' + localStorage.getItem('GUIDeasyConf');
        // this.$store.dispatch('inst_trySetSystemScreen', 'instApproveDemandEasy');
      }
    },
    async easyAVreadyToSave() {
      console.log('easyAVreadyToSave')
      const fieldsToSave = [
        'SOURCE_OF_INCOME',
        'WORK_JOB',
        'WORK_JOB_PHONE',
        'EXPER_RADIO',
        'WORK_TITLE',
        'AVERAGE_EXPENSES_PER_MONTH',
        'PURPOSE_OF_THE_LOAN',
        'CONTACT',
        'CONTACT_PHONE',
        'ASP',
        'AGREEMENT_KI_REQUEST'
      ];
      const fieldsToSaveVip = [
        'SOURCE_OF_INCOME',
        'AVERAGE_EXPENSES_PER_MONTH',
        'PURPOSE_OF_THE_LOAN',
        'CONTACT',
        'CONTACT_PHONE',
        'ASP',
        'AGREEMENT_KI_REQUEST'
      ]
      const selectFields = this.valuesVuex.SOURCE_OF_INCOME === 'пенсия' ? fieldsToSaveVip : fieldsToSave;

      console.log({selectFields})
      let check = true;
      selectFields.forEach((item) => {
        console.log(item)
        console.log(typeof this.valuesVuex[item] === 'string')
        console.log(this.valuesVuex.length)
        console.log(this.valuesVuex[item].length)
        if (typeof this.valuesVuex[item] === 'string' && this.valuesVuex[item].length === 0) {
          check = false
        }
      });
      console.log({check})
      if (check) {
        return await this.$store.dispatch('instSaveFormAV');
        // await this.$store.dispatch('instGetDemandState');
      } else {
        return false;
      }
    },
    getFormData() {
      this.$external.run({
        action: 'easyConfirm_get',
        jsonData: {
          GUID: this.GUID,
        }
      }).then((res) => {
        try {
          const formFormData = JSON.parse(res.ExecutionResult.formData);
          console.log('formFormData', formFormData)
        } catch (error) {
          console.log(error);
        }

      }).catch((error) => {
        console.log(error);
      });
    }
  },
  async mounted() {

    console.log('instLoaderGetDemandState mounted')
    await this.$store.dispatch('instGetDemandState');
    console.log('await end this.$store.dispatch(\'instGetDemandState\');')

    if (this.demandState.demandState === 0) {
      if (process.env.NODE_ENV !== 'development' && document.getElementById('jivo') === null) {
        let s;
        s = document.createElement('script');
        s.src = '//code.jivo.ru/widget/vtkA8XaWDb';
        s.id = 'jivo';
        document.head.appendChild(s);
      }

      // console.log('demandState === 0')
      this.$store.dispatch('saveSendData', {
        target: 'AGREEMENT_ALL',
        value: true
      });
      if (this.demandState.easyAV === 0) {
        console.log('easyAV === 0')
        const needLoadData = await this.easyAVreadyToSave();
        console.log({needLoadData})
        if (needLoadData) {
          this.getFormData();
        }
      }
      try {
        if (this.demandState.ID_ESIA === 0 && Object.keys(this.valuesVuex.ESIA).length !== 0) {
          this.$store.dispatch('sendEsiaData');
        }
      } catch ($event){
        console.log($event);
      }

      if(this.demandState.boxSelected === 0) {
        this.$store.dispatch('instGetBoxArr');
      }
      this.calcScreenForFirst();
    }
    else if (process.env.NODE_ENV === 'development') {
      console.log('if dev running');
      this.$store.dispatch('saveSendData', {
        target: 'AGREEMENT_ALL',
        value: true
      });
      console.log('dev await this.$store.dispatch(\'instGetBoxArr\');')
      await this.$store.dispatch('instGetBoxArr');
      console.log('dev await end this.$store.dispatch(\'instGetBoxArr\');')
      this.calcScreenForFirst();
    }
    else {
      switch (this.demandState.demandState){
        case -1:
          this.$store.dispatch('inst_trySetSystemScreen', 'instRejectTime');
          break;
        case 1:
          this.$store.dispatch('inst_trySetSystemScreen', 'instApproveDemandEasy');
          break;
        default:
          this.$store.dispatch('inst_trySetSystemScreen', 'instApproveDemandDefault');
          break;
      }
    }
  }
}

</script>

<style scoped>
#loaderWrap{height: 100vh;}
</style>